// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"e90da4e9","37":"84987ba3","171":"9226ab8a","429":"e49f3595","456":"0810cb24","507":"247e72f0"}[chunkId] + ".chunk.js";
};